import './diplome.css';
import React from 'react';
import { Link } from 'react-router-dom';
import certificate from './../header/images/certificate.png';

const Diplome = () => {
  // Date mock pentru diplome - poți înlocui cu date reale din API
  const diplomas = [
    // Exemplu de diplomă - momentan lista e goală
    // {
    //   id: 1,
    //   title: 'Bazele Contabilității',
    //   issueDate: '2024-12-15',
    //   progress: 100,
    //   status: 'completed'
    // }
  ];

  return (
    <div className="diplome-container">
      <div className="diplome-header">
        <h1 className="diplome-main-title">📜 Certificatele Tale</h1>
        <p className="diplome-subtitle">
          Colecționează certificate oficiale pentru fiecare curs completat
        </p>
      </div>

      {diplomas.length === 0 ? (
        <div className="diplome-empty-state">
          <div className="empty-state-content">
            <img src={certificate} alt="Certificate" className="empty-state-icon" />
            
            <h2 className="empty-state-title">Încă nu ai certificate</h2>
            
            <p className="empty-state-description">
              Completează cursurile disponibile pentru a obține certificate oficiale care îți confirmă cunoștințele în contabilitate.
            </p>

            <div className="empty-state-features">
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <div className="feature-text">
                  <strong>Certificate oficiale</strong>
                  <p>Documentează-ți progresul</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-icon">🎯</span>
                <div className="feature-text">
                  <strong>Completează cursurile</strong>
                  <p>Finalizează lecțiile și testele</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-icon">📊</span>
                <div className="feature-text">
                  <strong>Urmărește progresul</strong>
                  <p>Vezi stadiul fiecărui curs</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-icon">🏆</span>
                <div className="feature-text">
                  <strong>Descarcă diplomele</strong>
                  <p>Salvează și distribuie certificatele</p>
                </div>
              </div>
            </div>

            <div className="empty-state-actions">
              <Link to="/cursuri" className="btn-start-learning">
                Începe să înveți
              </Link>
              <Link to="/profil" className="btn-back-profile">
                Înapoi la profil
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="diplome-grid">
          {diplomas.map((diploma) => (
            <div key={diploma.id} className="diploma-card-item">
              <div className="diploma-card-header">
                <img src={certificate} alt="Certificate" className="diploma-card-icon" />
                <h3 className="diploma-card-title">{diploma.title}</h3>
              </div>

              <div className="diploma-card-body">
                <div className="diploma-info">
                  <span className="diploma-label">Data obținerii:</span>
                  <span className="diploma-value">{diploma.issueDate}</span>
                </div>

                <div className="diploma-info">
                  <span className="diploma-label">Status:</span>
                  <span className="diploma-status completed">Completat</span>
                </div>
              </div>

              <div className="diploma-card-actions">
                <button className="btn-view-diploma">Vezi certificat</button>
                <button className="btn-download-diploma">Descarcă PDF</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Secțiune cursuri în progres */}
      <div className="diplome-progress-section">
        <h2 className="section-title">🎓 Cursuri în progres</h2>
        <p className="section-subtitle">Continuă să înveți pentru a obține noi certificate</p>

        <div className="progress-courses-grid">
          <div className="progress-course-card">
            <div className="progress-course-header">
              <h3>Bazele Contabilității</h3>
              <span className="progress-badge">0% completat</span>
            </div>
            
            <div className="progress-bar-container-diplome">
              <div className="progress-bar" style={{ width: '0%' }}></div>
            </div>

            <div className="progress-course-footer">
              <span className="lessons-count">0/12 lecții</span>
              <Link to="/BazeleContabilitatii" className="btn-continue-course">
                Continua cursul
              </Link>
            </div>
          </div>

          <div className="progress-course-card">
            <div className="progress-course-header">
              <h3>Contabilitate Financiară</h3>
              <span className="progress-badge">0% completat</span>
            </div>
            
            <div className="progress-bar-container-diplome">
              <div className="progress-bar" style={{ width: '0%' }}></div>
            </div>

            <div className="progress-course-footer">
              <span className="lessons-count">0/15 lecții</span>
              <Link to="/ContabilitateFinanciara" className="btn-continue-course">
                Continuă cursul
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Diplome;
